module.exports = __webpack_public_path__ + "static/media/blog3_4.83455e35.webp";